<template>
    <div v-loading="loading">
        <el-tabs class="tabs" tab-position="left" v-model="activeName">
            <el-tab-pane
                    v-for="(item,index) of mallChannelList"
                    :key="item.code"
                    :label="item.name"
                    :name="'channelTab-'+index">
                <div class="common-el-tab-flex">
                    <div>
                        <strong>是否优先推荐：</strong>
                        <el-switch
                                @change="statusChange(item.code,$event)"
                                :value="item.status"
                                :active-value="1"
                                :inactive-value="0"/>
                    </div>
                    <div class="common-table">
                        <el-table :data="item.mallTransTypeSDKInfos" height="100%" row-key="id">
                            <el-table-column label="编号" type="index" align="center"/>
                            <!--<el-table-column label="支付通道名称" align="center" prop="transTypeName"/>-->
                            <el-table-column label="所属SDK" min-width="150" align="center" prop="paymentCode"/>
                            <el-table-column label="SDK是否可用" align="center" min-width="150">
                                <template slot-scope="scope">
                                    <el-switch
                                            @change="canUseChange(scope.row,$event)"
                                            :value="scope.row.canUse"
                                            :active-value="1"
                                            :inactive-value="0"
                                            active-text="是"
                                            inactive-text="否"/>
                                </template>
                            </el-table-column>

                            <el-table-column label="手续费" align="center">
                                <template slot-scope="scope">{{pointMove(scope.row.feeRate)}}%</template>
                            </el-table-column>
                            <el-table-column label="是否使用" align="center" min-width="150">
                                <template slot-scope="scope">
                                    <el-switch
                                            @change="useStatusChange(scope.row,$event)"
                                            :value="scope.row.status"
                                            :active-value="1"
                                            :inactive-value="0"
                                            active-text="是"
                                            inactive-text="否"/>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="150" align="center">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini" @click="editFunc(scope.row.id)">编辑</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>

        <div v-show="show" class="common-popup-bg">
            <div class="common-popup">
                <h3>编辑</h3>
                <el-form
                        ref="editForm"
                        class="common-popup-table"
                        size="medium"
                        label-width="160px" :model="form" :rules="rules">
                    <el-form-item label="支付通道名称：" prop="name">
                        <el-input placeholder="请输入" v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item v-if="productList.length" label="商品种类：" prop="productIds">
                        <el-checkbox-group class="group common-scroll" v-model="form.productIds">
                            <el-checkbox
                                    v-for="p of productList"
                                    :key="p.id"
                                    :label="p.id">{{p.idouNum}}金豆
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="客户端：" prop="productIds">
                        <el-checkbox-group class="group common-scroll" v-model="form.clientsTypes">
                            <el-checkbox
                                    v-for="p of clientsTypeList"
                                    :key="p.type"
                                    :label="p.type">{{p.name}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="手续费：" prop="feeRate">
                        <el-input style="width: 150px" placeholder="请输入" v-model.number="form.feeRate" type="number">
                            <i slot="append" class="icon-percent"></i>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="使用时间：" prop="date">
                        <el-time-picker
                                style="width: 250px !important;"
                                v-model="form.date"
                                is-range
                                format="HH:mm"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                range-separator="-"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"/>
                    </el-form-item>
                    <el-form-item label="单个玩家的每日限额：" prop="dailyLimit">
                        <el-input placeholder="请输入" style="width: 250px" v-model.number="form.dailyLimit">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="单个玩家的每月限额：" prop="monthlyLimit">
                        <el-input placeholder="请输入" style="width: 250px" v-model.number="form.monthlyLimit">
                            <template slot="append">元</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="是否需要录入银行卡：" prop="canShowView">
                        <el-switch
                                v-model="form.canShowView"
                                :active-value="1"
                                :inactive-value="0"/>
                    </el-form-item>
                </el-form>
                <footer>
                    <el-button size="small" @click="close('editForm')">取消</el-button>
                    <el-button size="small" type="primary" @click="submitForm('editForm')">保存</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                activeName: 'channelTab-0',
                show: false,
                form: {
                    id: '',
                    name: '',
                    productIds: [],
                    clientsTypes: [],
                    feeRate: '',
                    date: null,
                    dailyLimit: '',
                    monthlyLimit: '',
                    canShowView: '',
                },
                rules: {
                    feeRate: [
                        {required: true, message: '请输入手续费', trigger: 'blur'},
                        {
                            validator: (rule, value, callback) => {
                                if (value < 0 || value > 100) {
                                    callback(new Error('范围：0-100'))
                                } else {
                                    callback()
                                }
                            }, trigger: 'blur'
                        }
                    ],
                    date: [
                        {required: true, message: '请选择使用时间', trigger: 'blur'},
                        {
                            validator: (rule, value, callback) => {
                                let endTime = new Date(value[1]);
                                if (endTime.getHours() === 0 && endTime.getMinutes() === 0) {
                                    callback(new Error('结束时间不能是00:00'))
                                } else {
                                    callback()
                                }
                            }, trigger: 'blur'
                        }
                    ],
                    monthlyLimit: [
                        {
                            validator: (rule, value, callback) => {
                                if (value === null || value === '') {
                                    callback()
                                } else if (value && (value < 0 || !Number.isInteger(value))) {
                                    callback(new Error('请输入大于或等于0的整数'))
                                } else {
                                    callback()
                                }
                            }, trigger: 'blur'
                        }
                    ],
                    dailyLimit: [
                        {
                            validator: (rule, value, callback) => {
                                if (value === null || value === '') {
                                    callback()
                                } else if (value < 0 || !Number.isInteger(value)) {
                                    callback(new Error('请输入大于或等于0的整数'))
                                } else {
                                    callback()
                                }
                            }, trigger: 'blur'
                        }
                    ]
                },
                productList: [],// 商品种类列表
                clientsTypeList: [
                    {type: 2, name: 'IOS'},
                    {type: 1, name: '安卓'}
                ]
            }
        },
        computed: {
            ...mapState('mallPayChannel', ['mallChannelList'])
        },
        created() {
            this.getList()
        },
        methods: {
            ...mapActions('mallPayChannel', ['getMallChannelList', 'getMallChannelDetail', 'updateFirstStatus', 'updateUseStatus', 'updateSdkUseStatus', 'updateMallChannelDetail']),
            getList() {
                this.loading = true;
                this.getMallChannelList().then(() => {
                    this.loading = false;
                })
            },
            // 是否优先推荐
            statusChange(code, value) {
                this.updateFirstStatus({
                    isFirst: value,
                    transType: code
                }).then(() => {
                    this.$message.success('修改成功')
                })
            },
            // sdk是否可用
            canUseChange(row, value) {
                let text = '您确定要停用该SDK';
                if (value) {
                    text = '您确定要启用该SDK'
                }
                this.$confirm(text, '提示', {
                    type: 'info'
                }).then(() => {
                    this.updateSdkUseStatus({
                        id: row.id,
                        canUse: value
                    }).then(() => {
                        this.$message.success('修改成功')
                    })
                }).catch(() => {
                })
            },
            // 是否使用
            useStatusChange(row, value) {
                if (!row.canUse) {
                    this.$message.error('该SDK目前无法使用');
                    return
                }
                let text = '您确定要停用该渠道';
                if (value) {
                    text = '您确定要启用该渠道'
                }
                this.$confirm(text, '提示', {
                    type: 'info'
                }).then(() => {
                    this.updateUseStatus({
                        id: row.id,
                        isUsed: value
                    }).then(() => {
                        this.$message.success('修改成功')
                    })
                }).catch(() => {
                })
            },
            // 小数点移动
            pointMove(number) {
                if (Number.isInteger(number)) {
                    return number * 100
                } else {
                    let text = (number.toString() + '00').split('');
                    let index = text.indexOf('.');
                    [text[index], text[index + 1], text[index + 2]] = [text[index + 1], text[index + 2], '.'];
                    return +text.join('')
                }
            },
            editFunc(id) {
                this.getMallChannelDetail({id}).then((res) => {
                    this.productList = res.data.productInfos;
                    this.form = {
                        id,
                        name: res.data.transTypeName,
                        productIds: this.productList.filter(item => item.isSelected === 1).map(item => item.id),
                        clientsTypes: res.data.clientsTypes,
                        feeRate: this.pointMove(res.data.feeRate),
                        date: [res.data.displayStartTime, res.data.displayEndTime],
                        dailyLimit: res.data.dailyLimit,
                        monthlyLimit: res.data.monthlyLimit,
                        canShowView: res.data.canShowView
                    };
                    this.show = true
                })
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let {date, ...params} = Object.assign({}, this.form, {
                            feeRate: this.form.feeRate / 100
                        });
                        params.displayStartTime = date[0];
                        params.displayEndTime = date[1];
                        this.updateMallChannelDetail(params).then(() => {
                            this.$message.success('保存成功');
                            this.getList();
                            this.close(formName)
                        })
                    }
                });
            },
            close(formName) {
                this.$refs[formName].resetFields();
                this.show = false
            }
        }
    }
</script>
<style lang="scss" scoped>
    .tabs {
        height: 100%;
        :global(.el-tabs__content) {
            height: 100%;
        }
        :global(.el-tab-pane) {
            height: 100%;
        }
    }

    .common-popup-table {
        @extend %scrollbar;

        @media (max-height: 800px) {
            max-height: 400px;
        }
    }

    .group {
        display: flex;
        flex-wrap: wrap;
        width: 400px;
        max-height: 200px;
        padding: 5px 0 0 5px;
        border: 1px solid $border-color;
        border-radius: 4px;

        :global(.el-checkbox) {
            display: flex;
            width: 33.33%;
            padding-bottom: 5px;
            margin-right: 0;
        }
        :global(.el-checkbox__inner) {
            margin-top: 2px;
        }
        :global(.el-checkbox__label) {
            padding-right: 5px;
            white-space: normal;
        }
    }
</style>